module.exports = __webpack_public_path__ + "img/agenda.baf2614e.svg";